<template>
  <div class="mapBox">
    <div class="SiteCount">
      <p>
        站点总数:
        <span ref="siteTotal">0</span>
      </p>
      <p>
        告警个数:
        <span ref="siteWarn">0</span>
      </p>
      <p>
        停运个数:
        <span ref="shutDown">0</span>
      </p>
      <p>
        断电个数:
        <span ref="siteOffline">0</span>
      </p>
    </div>
    <div class="map_company" ref="mapImgBox" :style="{backgroundImage: 'url(' + imgMap.url + ')'}">
      <Spin fix v-if="imgMap.imgLoad"></Spin>
      <div
        class="site_item"
        :style="{top: item.top, left: item.left}"
        v-for="item in siteList"
        :key="item.id"
        @click="goSiteDetection(item)"
      >
        <div class="title" style="font-size: 0.875em">
          <Icon type="md-code" />
          {{ item.name }}
        </div>
        <img src="@/assets/alert/point1.png" v-if="item.statusName == '正常'" alt />
        <img src="@/assets/alert/point2.png" v-else-if="item.statusName == '告警'" alt />
        <img src="@/assets/alert/point6.png" v-else-if="item.statusName == '断电'" alt />
        <img src="@/assets/alert/point3.png" v-else-if="item.statusName == '停机'" alt />
        <img src="@/assets/alert/point5.png" v-else-if="item.status == '128'" alt />
        <img src="@/assets/alert/point4.png" v-else-if="item.status == '16'" alt />
        <img src="@/assets/alert/point2.png" v-else alt />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mapBox {
  position: relative;
  height: 100%;
}

.SiteCount {
  width: 140px;
  height: 128px;
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 3;
  p {
    margin: 0px auto;
    font-size: 18px;
    color: #009688;
  }
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
  text-align: left;
    padding: 10px;
}

.map_company {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .site_item {
    position: absolute;
    width: 40px;
    height: 40px;
    cursor: pointer;
    .title {
      width: auto;
      white-space: nowrap;
      background: rgba(0, 0, 0, 0.6);
      position: absolute;
      top: 0;
      left: 50%;
      padding: 0.25em;
      border-radius: 0.25em;
      color: #fff;
      transform: translate(-50%, -110%);
      display: flex;
      align-items: center;
      i {
        font-size: 1.25em;
        margin-right: 0.25em;
      }
    }
    img {
      width: 100%;
    }
  }
}
</style>

<script>
import { BaseUrl } from "../../../http/config";

export default {
  data() {
    return {
      imgMap: {
        imgLoad: true,
        url: null,
        wRadio: null,
        imgClass: null,
      },
      // 企业对象
      company: {
        id: null,
        name: null,
      },
      siteList: [], // 站点列表,
      roleList: [], // 权限列表
    };
  },
  components: {},
  created: async function () {
    // 获取权限
    this.roleList = this.$Local.getRole();
    if (
      !this.$Local.getLocal("bindCompanies") ||
      !this.$Local.getLocal("bindCompanies", "object")[0].uuid
    ) {
      this.$Local.removeLocal(["user", "role"]);
      this.$Notice.warning({
        title: "没有访问的权限",
        desc: "请联系管理员，或登录其他账号",
      });
      this.$router.push("/");
      return;
    }
    this.company.name = this.$Local.getLocal("bindCompanies", "object")[0].name;
    await this.getCompanyDeils(); // 获取公司信息(厂区图片)
    await this.getSiteList(); // 获取站点列表
    await this.getHomeMapCount(); // 获取站点统计
    this.$nextTick(() => {
      this.mapInit();
    });
  },
  methods: {
    // 图片初始化
    mapInit: async function () {
      let siteImg = new Image();
      siteImg.src = this.imgMap.url;
      this.imgMap.imgClass = siteImg;
      siteImg.onload = this.computedSize;
    },
    // 计算宽高计算位置
    computedSize() {
      // 如果不是当前路由则去掉事件
      if (this.$route.path != "/chome") {
        window.removeEventListener("resize", this.computedSize);
        return false; // 阻止代码继续执行
      }
      this.imgMap.imgLoad = false;
      let width = this.$refs.mapImgBox.clientWidth;
      let height = this.$refs.mapImgBox.clientHeight;
      let iWidth = this.imgMap.imgClass.width;
      let iheight = this.imgMap.imgClass.height;
      let radio = iWidth / iheight;
      let w = width;
      let h = width / radio;
      if (h < height) {
        h = height;
        w = radio * height;
      }
      this.imgMap.wRadio = w / iWidth;

      // 计算站点位置
      let siteList = this.siteList;
      siteList.map((res, index) => {
        this.$set(
          this.siteList[index],
          "top",
          res.imgUrlY * this.imgMap.wRadio - 25 + "px"
        );
        this.$set(
          this.siteList[index],
          "left",
          res.imgUrlX * this.imgMap.wRadio - 12.5 + "px"
        );
      });
      window.addEventListener("resize", this.computedSize);
    },
    // 获取企业详情
    getCompanyDeils() {
      return new Promise((resovle, reject) => {
        this.$api.A_Company.getCompanyDeils({}, ["uuid", "company"]).then(
          (res) => {
            if (res.code == 0) {
              if (this.imgMap.url) {
                this.$Notice.warning({
                  title: "该企业还没厂区图",
                  desc: "请联系管理员尽快补充",
                });
                return;
              }
              this.imgMap.url = res.data.imgUrl;
              resovle();
            } else {
              this.$Notice.warning({
                title: "获取企业字段失败",
                desc: res.message || "请联系管理员",
              });
            }
          }
        );
      });
    },
    // 获取站点枚举值
    getSiteList() {
      return new Promise((resolve, reject) => {
        this.$api.Deploy.getSiteList({ paging: false }, [
          "uuid",
          "company",
        ]).then((res) => {
          if (res.code == 0) {
            let data = res.data;
            this.siteList = data;
            resolve();
          } else {
            this.$Notice.warning({
              title: "获取站点枚举失败",
              desc: res.message || "请联系管理员",
            });
          }
        });
      });
    },
    // 去站点检测
    goSiteDetection(parmas) {
      this.$router.push({
        // 路由记录页面
        path: "/chome/siteDetection",
        query: {
          siteMn: parmas.mn,
          siteId: parmas.id,
          date: new Date().getTime(),
        },
      });
    },
    //获取站点统计
    getHomeMapCount() {
      return new Promise((resolve, reject) => {
        this.$api.Deploy.getHomeMapCount({ paging: false }, [
          "uuid",
          "company",
        ]).then((res) => {
          if (res.code == 0) {
            this.$refs.siteTotal.innerText = res.data[0];
            this.$refs.siteWarn.innerText = res.data[1];
            this.$refs.shutDown.innerText =res.data[2];
            this.$refs.siteOffline.innerText =res.data[3];
            resolve();
          } else {
            this.$Notice.warning({
              title: "获取站点统计数失败",
              desc: res.message || "请联系管理员",
            });
          }
        });
      });
    },
  },
};
</script>